module.exports = __webpack_public_path__ + "static/img/1.1ae68d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/dreamworks/article/1.jpg
// module id = 913A
// module chunks = 1